import React, { memo, Fragment, Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight, faClock, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { Card, Container, Row, Col, Form, Button, Collapse } from 'react-bootstrap';
import moment from 'moment';
import 'moment/locale/es';

import DatePicker from '../../../components/UI/DatePicker/DatePicker';

class PickingInt extends Component {
    state = {
        fecha_activa_inicio: new Date(),
        fecha_activa_fin: new Date(),
        maxDate: new Date()
    }

    componentDidMount() {
        this.setDates();
    }

    componentDidUpdate(prevProps) {
        if (this.props.cantDiasCalendarizados && this.props.cantDiasCalendarizados !== prevProps.cantDiasCalendarizados) {
            this.setDates();
        }
    }

    setDates = () => {
        let maxDate = new Date();
        maxDate.setMonth(maxDate.getMonth() + 1);
        maxDate.setHours(23, 59, 59, 0);

        let fecha_activa_fin = new Date();
        if (this.props.cantDiasCalendarizados && this.props.cantDiasCalendarizados > 0) {
            fecha_activa_fin.setDate(fecha_activa_fin.getDate() + this.props.cantDiasCalendarizados);
        }

        this.setState({ maxDate, fecha_activa_fin });
    };

    onChangeDate = (name, dates) => {
        const [start, end] = dates;

        this.setState({ fecha_activa_inicio: start, fecha_activa_fin: end });
        if (end) {
            this.props.actualizarFiltro({ target: { name }, date: dates });
        }
    }

    checkDates = (pFechaInicio, pFechaFin) => {
        if (!pFechaInicio && pFechaFin) {
            pFechaInicio = pFechaFin;
        }
        else {
            if (pFechaInicio && !pFechaFin) {
                pFechaFin = pFechaInicio;
            }
            else {
                pFechaInicio = new Date();
                pFechaFin = new Date();
            }
        }

        let newDateIni = new Date(pFechaInicio);
        newDateIni.setHours(0, 0, 0, 0);

        let newDateFin = new Date(pFechaFin);
        newDateFin.setHours(23, 59, 59, 0);

        this.setState({ fecha_activa_fin: newDateFin, fecha_activa_inicio: newDateIni });
        this.props.actualizarFiltro({ target: { name: "fecha_activa" }, date: [newDateIni, newDateFin] });
    }

    onClickPreviousDate = () => {

        let fecha_inicio = this.state.fecha_activa_inicio;
        let fecha_final = this.state.fecha_activa_fin;
        if (fecha_inicio && fecha_final) {

            let newDate = new Date(fecha_inicio);
            if (newDate > new Date()) {
                newDate.setDate(newDate.getDate() - 1);
                this.setState({ fecha_activa_inicio: newDate });
                this.props.actualizarFiltro({ target: { name: "fecha_activa" }, date: [newDate, fecha_final] });
            }
        }
        else {
            this.checkDates(fecha_inicio, fecha_final);
        }
    }

    onClickNextDate = () => {

        let fecha_inicio = this.state.fecha_activa_inicio;
        let fecha_final = this.state.fecha_activa_fin;
        if (fecha_inicio && fecha_final) {

            let newDate = new Date(fecha_final);
            if (this.state.maxDate > newDate) {
                newDate.setDate(newDate.getDate() + 1);
                this.setState({ fecha_activa_fin: newDate });
                this.props.actualizarFiltro({ target: { name: "fecha_activa" }, date: [fecha_inicio, newDate] });
            }
        }
        else {
            this.checkDates(fecha_inicio, fecha_final);
        }
    }

    groupElementsByHourInDay = (arreglo, key, rangoMinutos) => {

        moment.locale("es");
        let groupedArray = [];

        if (Array.isArray(arreglo) && arreglo.length > 0) {
            let iterations = (24 * 60) / rangoMinutos;

            const ordenesFuturo = arreglo.reduce((group, item) => {

                let itemKey = new Date(item[key]);
                let grupoKey = moment.utc().year(itemKey.getFullYear()).month(itemKey.getMonth()).date(itemKey.getDate()).startOf('day').toISOString();

                (group[grupoKey] = group[grupoKey] || []).push(item);
                return group;
            }, {});

            const propertiesFuturo = Object.keys(ordenesFuturo);
            propertiesFuturo.forEach(fechaFuturo => {

                let itemsAdded = 0;

                let counter = moment.utc(moment(fechaFuturo)).startOf('day');
                let projection = moment.utc(moment(fechaFuturo)).startOf('day');

                for (let i = 0; i <= iterations; i++) {
                    projection.add(rangoMinutos, "minutes");
                    let dateTest = null;

                    ordenesFuturo[fechaFuturo].forEach(item => {

                        dateTest = moment.utc(item[key]);
                        let hoursDifference = dateTest.diff(counter, 'hours', true);

                        const rangoHoras = rangoMinutos / 60;

                        if (hoursDifference >= 0 && (hoursDifference / rangoHoras) < rangoHoras) {

                            let dateLabel = `${counter.locale("es").format("dddd")} ${counter.format('DD/MM/yyyy')}`;
                            let timeLabel = `${counter.format("hh:mm a")} - ${projection.format("hh:mm a")}`;

                            const index = groupedArray.findIndex(grupo => grupo.day === dateLabel && grupo.hour === timeLabel);
                            if (index >= 0) {

                                groupedArray[index].items.push(item);
                                itemsAdded++;

                            } else {
                                groupedArray.push({
                                    day: dateLabel,
                                    hour: timeLabel,
                                    items: [item]
                                });
                                itemsAdded++;
                            }
                        }
                    });

                    if (itemsAdded === ordenesFuturo[fechaFuturo].length) {
                        break;
                    }

                    counter.add(rangoMinutos, "minutes");
                }
                return null;
            });
        } else {
            return [];
        }

        return groupedArray;
    }

    tarjetaOrden = (orden, rangoHoras, key = 0) => (
        <div className="picking-orden" key={key}>
            <div className="row">
                <div className="col">
                    <p className="numero">Orden #{orden.Orden_Id}</p>
                </div>
                <div className="col text-right">
                    <p className={"audit audit-" + (orden.estatusAuditoria ? "si" : "no")}>{orden.estatusAuditoria ? "Auditada" : "No Auditada"}</p>
                </div>
            </div>
            <div className="row">
                <div className="col-10">
                    {
                        Array.isArray(orden.Sucursales) ? orden.Sucursales.map((sucursal, i) => {
                            return <button title={sucursal.Nombre} key={i} className="btn btn-sucursal">{orden.Orden_Suc_Factura != sucursal.Suc_Id && <i className="flaticon-inbox"></i>} {sucursal.Nombre}</button>
                        }) : ""
                    }
                </div>
                <div className="col-2">
                    <button onClick={() => { this.props.seleccionarOrden(orden, rangoHoras) }} className="btn-circle"><FontAwesomeIcon icon={faArrowRight} /></button>
                </div>
            </div>
        </div>
    );

    generarTarjetasOrden = (lista, rangoHoras) => {
        return (
            <>
                {lista.map((orden, i) => {
                    return this.tarjetaOrden(orden, rangoHoras, i);
                })}
            </>
        );
    }

    onClickFiltrarOrdenes = () => {

        const { fecha_activa_inicio, fecha_activa_fin } = this.state;

        if (fecha_activa_inicio && fecha_activa_fin) {
            this.props.filtrarOrdenes(
                [fecha_activa_inicio, fecha_activa_fin],
                this.props.filtro.sucursalApoyo.selected == "none" ? null : this.props.filtro.sucursalApoyo.selected,
                this.props.filtro.estadoAuditoria.selected
            );
        }
        else {
            this.checkDates(fecha_activa_inicio, fecha_activa_fin);
        }
    }

    render() {
        const { fecha_activa_inicio, fecha_activa_fin, maxDate } = this.state;
        const { filtro, ordenes, cargando } = this.props;

        let ordenesIndeterminadas = [];

        let ordenesPasadas = ordenes.filter(orden => {
            let isBeforeToday = (moment().diff(moment(orden.Fecha), 'days')) > 0
            let isOnToday = (moment().diff(moment(orden.Fecha), 'days')) === 0
            let timePassed = (moment().diff(moment(orden.Fecha), 'seconds', true)) > 0

            let shouldInclude = (isBeforeToday || isOnToday) && timePassed;
            if (!shouldInclude) {
                ordenesIndeterminadas.push(orden);
            }

            return shouldInclude;
        }).map((e, i) => {
            return (
                <Fragment key={i}>
                    {this.tarjetaOrden(e, null, i)}
                </Fragment>
            )
        });

        let intervaloHorasAgrupamiento = this.props.intervaloRecogerTienda ? this.props.intervaloRecogerTienda : 1;
        intervaloHorasAgrupamiento *= 60;

        let lastFutureDate = null;
        let ordenesAFuturo = this.groupElementsByHourInDay(
            ordenes.filter(orden => {
                let isBeforeToday = (moment().diff(moment(orden.Fecha), 'days')) > 0;
                let timePassed = (moment().diff(moment(orden.Fecha), 'seconds', true)) > 0;
                let shouldInclude = !isBeforeToday && !timePassed;

                if (shouldInclude) {
                    let index = 0;

                    ordenesIndeterminadas.forEach((x, i) => {
                        if (JSON.stringify(x) === JSON.stringify(orden)) {
                            index = i;
                        }
                    });

                    ordenesIndeterminadas.splice(index, 1);
                }

                return shouldInclude;
            }),
            "Fecha", intervaloHorasAgrupamiento).map((e, i) => {

                const dayLabel = !lastFutureDate || e.day !== lastFutureDate ?
                    <div className="row">
                        <div className="col-auto grupo-ordenes-dia"><span style={{ textTransform: 'capitalize' }}>{e.day}</span></div>
                        <div className="col grupo-ordenes-dia-linea"></div>
                    </div> : null;
                lastFutureDate = e.day;

                return (
                    <Fragment key={i}>
                        <div className="row">
                            <div className="col col-lg-12">
                                {dayLabel}
                                <h4><FontAwesomeIcon icon={faClock} /> {e.hour} </h4>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                {this.generarTarjetasOrden(e.items, e.hour)}
                            </div>
                        </div>
                    </Fragment>
                )
            });

        ordenesIndeterminadas = ordenesIndeterminadas.map((e, i) => {
            return (
                <Fragment key={i}>
                    {this.tarjetaOrden(e, null, i)}
                </Fragment>
            )
        });

        return (
            <>
                <Collapse in={filtro.mostrar}>
                    <Card className="picking-filter">
                        <Card.Body>
                            <Container>
                                <Row>
                                    <Col>
                                        <h1>Filtrar Búsqueda de Órdenes</h1>
                                        <div className="content-bg">
                                            <Row>
                                                <Col xs={12} md={4}>
                                                    <Form.Group controlId="sucursalFactura">
                                                        <Form.Label>Sucursal Factura:</Form.Label>
                                                        <Form.Control readOnly value={filtro.sucursalFactura.selected} name="sucursalFactura" as="select" onChange={(e) => { this.props.actualizarFiltro(e); }}>
                                                            {
                                                                filtro.sucursalFactura.options.map((option) => <option key={option.Id} value={option.Id}>{option.Nombre}</option>)
                                                            }
                                                        </Form.Control>
                                                    </Form.Group>
                                                </Col>
                                                <Col xs={12} md={4}>
                                                    <Form.Group controlId="sucursalApoyo">
                                                        <Form.Label>Sucursales de Apoyo:</Form.Label>
                                                        <Form.Control value={filtro.sucursalApoyo.selected} name="sucursalApoyo" as="select" onChange={(e) => { this.props.actualizarFiltro(e); }}>
                                                            <option value="none">--Todos--</option>
                                                            {
                                                                filtro.sucursalApoyo.options.map((option) => <option key={option.Id} value={option.Id}>{option.Nombre}</option>)
                                                            }
                                                        </Form.Control>
                                                    </Form.Group>
                                                </Col>
                                                <Col xs={12} md={4}>
                                                    <Form.Group controlId="estadoAuditoria">
                                                        <Form.Label>Estado:</Form.Label>
                                                        <Form.Control value={filtro.estadoAuditoria.selected} name="estadoAuditoria" as="select" onChange={(e) => { this.props.actualizarFiltro(e); }}>
                                                            {
                                                                filtro.estadoAuditoria.options.map((option) => <option key={option.Id} value={option.Id}>{option.Nombre}</option>)
                                                            }
                                                        </Form.Control>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs={12} md={4}>
                                                    <div className="form-group">
                                                        <label>Fecha:</label>
                                                        <DatePicker disabled={cargando} name="filtroFecha" value={fecha_activa_inicio} onChange={this.onChangeDate} props={{
                                                            selectsRange: true,
                                                            startDate: fecha_activa_inicio,
                                                            endDate: fecha_activa_fin,
                                                            minDate: new Date(),
                                                            maxDate: maxDate
                                                        }} />
                                                    </div>
                                                </Col>
                                                <Col xs={12} md={4} className="text-center">
                                                    <Button disabled={cargando} onClick={this.onClickFiltrarOrdenes} variant="dark">Filtrar Órdenes</Button>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </Card.Body>
                    </Card>
                </Collapse>
                <div className="picking-ordenes">
                    <Container style={{ minHeight: '65vh' }}>
                        <Row>
                            <Col xs={12} md={6} className="offset-md-3">
                                <Row className="date-selector">
                                    <div className="col-auto">
                                        <button disabled={cargando} id="btnPreviousDay" className="btn btn-primary" onClick={this.onClickPreviousDate}><FontAwesomeIcon icon={faChevronLeft} /></button>
                                    </div>
                                    <div className="col-8">
                                        <DatePicker disabled={cargando} name="fecha_activa" value={fecha_activa_inicio} onChange={this.onChangeDate} props={{
                                            selectsRange: true,
                                            startDate: fecha_activa_inicio,
                                            endDate: fecha_activa_fin,
                                            minDate: new Date(),
                                            maxDate: maxDate
                                        }} />
                                    </div>
                                    <div className="col-2">
                                        <button disabled={cargando} id="btnNextDay" className="btn btn-primary" onClick={this.onClickNextDate}><FontAwesomeIcon icon={faChevronRight} /></button>
                                    </div>
                                </Row>
                            </Col>
                        </Row>
                        {
                            Array.isArray(ordenesPasadas) && Array.isArray(ordenesAFuturo) ?
                                ordenesPasadas.length === 0 && ordenesAFuturo.length === 0 ?
                                    <Row className="text-center mt-4">
                                        <Col className="text-center">{cargando ? "Cargando datos..." : "No hay órdenes que mostrar"}</Col>
                                    </Row>
                                    :
                                    ""
                                :
                                ""
                        }
                        {
                            Array.isArray(ordenesIndeterminadas) ?
                                ordenesIndeterminadas.length > 0 ?
                                    <>
                                        <div className="row mt-4">
                                            <div className="col">
                                                <h3>Indeterminadas</h3>
                                            </div>
                                        </div>
                                        <Row>
                                            <div className="col">
                                                {ordenesIndeterminadas}
                                            </div>
                                        </Row>
                                    </>
                                    :
                                    ""
                                :
                                ""
                        }
                        {
                            Array.isArray(ordenesPasadas) ?
                                ordenesPasadas.length > 0 ?
                                    <>
                                        <div className="row mt-4">
                                            <div className="col">
                                                <h3>{this.props.ordenes.filter(orden => orden.estatus === "aplicada").length === this.props.ordenes.length ? "Procesadas" : "Pendientes"}</h3>
                                            </div>
                                        </div>
                                        <Row>
                                            <div className="col">
                                                {ordenesPasadas}
                                            </div>
                                        </Row>
                                    </>
                                    :
                                    ""
                                :
                                ""
                        }
                        {
                            Array.isArray(ordenesAFuturo) ?
                                ordenesAFuturo.length > 0 ?
                                    <>
                                        <div className="row mt-4">
                                            <div className="col">
                                                <h3>A Futuro</h3>
                                            </div>
                                        </div>
                                        {ordenesAFuturo}
                                    </>
                                    :
                                    ""
                                :
                                ""
                        }
                    </Container>
                </div>
            </>
        )
    }
}

const mapStateToProps = state => {
    return {
        token: state.usuario.token,
        empresa: state.parametros.empresa,
        sucursal: state.parametros.sucursal,
        callCenter: state.parametros.callCenter
    };
};

export default connect(mapStateToProps)(withRouter(memo(PickingInt)));